import Chain from "./Chain";
import Results from "./Results/Results";
import React, { useEffect, useState} from "react";
import "./Amino.css";

function Amino() {
  const masesmono = new Map([
    ["A",  7103711],
    ["R", 15610111],
    ["N", 11404293],
    ["D", 11502694],
    ["C", 10300919],
    ["E", 12904259],
    ["Q", 12805858],
    ["G",  5702146],
    ["H", 13705891],
    ["I", 11308406],
    ["L", 11308406],
    ["K", 12809496],
    ["M", 13104049],
    ["F", 14706841],
    ["P",  9705276],
    ["S",  8703203],
    ["T", 10104768],
    ["W", 18607931],
    ["Y", 16306333],
    ["V",  9906841],
  ]);

  const masesaverage = new Map([
    ["A",  7107880],
    ["R", 15618750],
    ["N", 11410380],
    ["D", 11508860],
    ["C", 10313880],
    ["E", 12911550],
    ["Q", 12813070],
    ["G",  5705190],
    ["H", 13714110],
    ["I", 11315940],
    ["L", 11315940],
    ["K", 12817410],
    ["M", 13119260],
    ["F", 14717660],
    ["P",  9711670],
    ["S",  8707820],
    ["T", 10110510],
    ["W", 18621320],
    ["Y", 16317600],
    ["V",  9913260],
  ]);

  let partsmass = new Map([]);
  const e = " ..... ";

  const [refresh, doRefresh] = useState(true);
  const [peptid, setPeptid] = useState(
    "GSSHHHHHHSSGLVPRGSHMGSSFLSPEHQRVQQRKESKKPPAKLQPRALAGWLRPEDGGQAEGAEDEMEVRFNAPFDVGIKLSGVQYQQHSQALGKFLQDILWEEAKEAPADK"
  );
  const [out_mass, setOut_mass] = useState(150590418); //zmierzona masa
  const [out_mass_display, setOut_mass_display] = useState(1505.90418);
  const [toggled, setToggled] = useState(true);

  const [monoPeptidMass, setMonoPeptidMass] = useState(12541.21575);
  const [averPeptidMass, setAverPeptidMass] = useState(12548.8855);

  const [peptidMinusMonoMass, setPeptidMinusMonoMass] = useState(0.0);
  const [peptidMinusAverMass, setPeptidMinusAverMass] = useState(0.0);

  let mases = toggled ? masesaverage : masesmono;

  let sum = 0;
  for (let i = 0; i < peptid.length; i++) sum = sum + mases.get(peptid[i]);
  sum = sum + 18;

  // let cur_mass = 0;
  // let best_mass = 0; //najbardziej zblizona masa

  // let cur_output = ""; //aktualna badana sekwencja
  // let best_output = ""; //najbardziej zbliżona sekwencja

  // let fin_mass;
  // let fin_output;

  // let first = 0;
  // let last = 0;

  ////STARA WERSJA

  // cur_output = cur_output + peptid[0];
  // cur_mass = cur_mass + mases.get(peptid[0]) + 18;

  // for (let i = 0; i < peptid.length * 2; i++) {
  //   if (Math.abs(cur_mass - out_mass) < Math.abs(best_mass - out_mass)) {
  //     best_output = cur_output;
  //     best_mass = cur_mass;

  //     fin_output = cur_output;
  //     fin_mass = cur_mass;
  //   }

  //   //sprawdzamy dwa przypadki - czy dodanie z tyy czy odjcie z przodu spowoduje zblizenie sie do wyniku
  //   if (
  //     Math.abs(cur_mass - mases.get(peptid[first]) - out_mass) <
  //     Math.abs(cur_mass + mases.get(peptid[last + 1]) - out_mass)
  //   ) {
  //     cur_mass = cur_mass - mases.get(peptid[first]);
  //     cur_output = cur_output.substring(1);
  //     first++;
  //   } else {
  //     cur_mass = cur_mass + mases.get(peptid[last + 1]);
  //     cur_output = cur_output + peptid[last + 1];
  //     last++;
  //   }
  // }

  //funkcja do mierzenia masy całkowitej wrzcuonego peptidu
  const calculateMass = () =>{
    let monomass = 1800000;
    let avermass = 1800000;
    for (let i = peptid.length - 1; i >= 0; i--) {
      monomass = monomass + masesmono.get(peptid[i]);
      avermass = avermass + masesaverage.get(peptid[i]);
    }
    setPeptidMinusMonoMass((monomass-out_mass)/100000);
    setPeptidMinusAverMass((avermass-out_mass)/100000);

    if (monomass==1800000)setMonoPeptidMass(0.0);
    else setMonoPeptidMass(monomass/100000);
    if (avermass==1800000)setAverPeptidMass(0.0);
    else setAverPeptidMass(avermass/100000);
    // console.log ("masa mono,aver: ", monomass/100000, avermass/100000);
  }

  useEffect(
    () => {
      calculateMass();
      console.log("peptidpeptid");
    },[peptid,out_mass]
  );

  const calculate = () => {
    // console.log("calculate");
    for (let le = peptid.length; le >= 1; le--) {
      for (let ii = peptid.length; ii >= le; ii--) {
        let str = "";
        let ch = peptid.length - ii;
        let partmass = 0;
        for (let iii = 0; iii < le; iii++) {
          str = str + peptid[ch];
          partmass = partmass + mases.get(peptid[ch]);
          ch++;
        }
        partsmass.set(str, partmass + 1800000);
      }
    }
    partsmass = new Map(
      [...partsmass.entries()]
        .sort((b, a) => Math.abs(b[1] - out_mass) - Math.abs(a[1] - out_mass))
        .slice(0, 100)
    );
  };

  calculate();

  // console.log("out_mass",out_mass);

  return (
    <div className="amino">
      <button 
        className={`toggle-btn ${toggled ? "toggled" : ""}`}
        onClick={() => {
          setToggled(!toggled)
          doRefresh(refresh?false:true);
        }}
      >
        <div className="thumb"></div>
      </button>
      <text
        style={{
          color: `${toggled ? "#10795f" : "#442121"}`,
          fontSize: 45,
          fontFamily: "Consolas",
        }}
      >
        {toggled ? "aver" : "mono"}
      </text>

      <text style={{ fontSize: 50, marginLeft: 150, marginRight: 300 }}>AMINOMASS</text>
      <p>
        {"peptyd: "}
        <input
          name="inputChain"
          size={200}
          style={{ textAlignVertical: "center", textAlign: "center" }}
          value={peptid}
          onChange={(event) => {
            setPeptid(event.currentTarget.value);
            doRefresh(refresh?false:true);
            // calculateMass();
            // console.log("refresz parenet   ", refresh);
          }}
        />
      </p>
      <p>
      
        <span className={`monoMass ${toggled ? "toggledMass" : ""}`}>masa MONO całego peptydu: {monoPeptidMass}</span>
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span> 
        <span className={`averMass ${toggled ? "" : "toggledMass"}`}>masa AVERAGE całego peptydu: {averPeptidMass}</span> 
      </p>
      <p>
        {"zmierzona masa: "}
        <input
          name="inputMass"
          width={200}
          style={{ textAlignVertical: "center", textAlign: "center" }}
          value={out_mass_display}
          onChange={(event) => {
            setOut_mass_display(event.currentTarget.value);
            setOut_mass(Math.round(event.currentTarget.value*100000));
            doRefresh(refresh?false:true);
          }}
        />
      </p>
      {/* <p>
        {"łańcuch aminokwasów z najbardziej zbliżoną do podanej masy: " +
          fin_output}
        {"   masa tego łańcucha: " + fin_mass}
      </p> */}
      <p></p>
      {/* <Chain></Chain> */}
      <p>
        <span className={`monoMass ${toggled ? "toggledMass" : ""}`}> różnica    [masa peptydu MONO] - [zmierzona masa] : {peptidMinusMonoMass} </span>
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span> 
        <span className={`averMass ${toggled ? "" : "toggledMass"}`}> różnica    [masa peptydu AVER] - [zmierzona masa] : {peptidMinusAverMass} </span>
      </p>
      <Results
        peptid={peptid}
        out_mass={out_mass}
        partsmass={partsmass}
        refresh={refresh}
      ></Results>
    </div>
  );
}
export default Amino;
